const translations = {
    chemicalCost: 'Chemical Cost'
};

export default translations;
